module.exports = __webpack_public_path__ + "img/start.ed00ae9f.svg";